import React from "react";
import { withRouter } from "react-router-dom";
import DesktopMenu from "./DesktopMenu";

import useTopMenu from "./useTopMenu";
import MobileMenu from "./MobileMenu/MobileMenu";
import DesktopSideMenu from "./DesktopSideMenu";
import useLayout from "../../../hooks/useLayout/useLayout";

const TopMenu = withRouter((props) => {
  const {
    state,
    authData,
    authActions,
    items,
    activeLink,
    subActiveLink,
    setActiveLink,
    setSubActiveLink,
    actions,
    setSubMenu,
    subMenu,
    isMobile,
  } = useTopMenu(props);

  const { selectedLayout, setLayout } = useLayout();

  return authData.isAuthenticated && !authData.user.mustRenewPassword ? (
    isMobile ? (
      <>
        <MobileMenu
          items={items}
          activeLink={activeLink}
          setActiveLink={setActiveLink}
          subActiveLink={subActiveLink}
          setSubActiveLink={setSubActiveLink}
        />
        <div className="mb-5 pb-5"></div>
      </>
    ) : selectedLayout == "layout1" ? (
      <DesktopMenu
        items={items}
        activeLink={activeLink}
        subMenu={subMenu}
        subActiveLink={subActiveLink}
        setActiveLink={setActiveLink}
        setSubActiveLink={setSubActiveLink}
        setSubMenu={setSubMenu}
      />
    ) : (
      <DesktopSideMenu
        items={items}
        activeLink={activeLink}
        subMenu={subMenu}
        subActiveLink={subActiveLink}
        setActiveLink={setActiveLink}
        setSubActiveLink={setSubActiveLink}
        setSubMenu={setSubMenu}
      />
    )
  ) : (
    <></>
  );
});

export default TopMenu;
